import {
  defaultShouldDehydrateQuery,
  isServer,
  QueryClient,
} from '@ts-rest/react-query/tanstack';
import { cache } from 'react';

function makeQueryClient(streamPendingQueries = false) {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
      },

      ...(streamPendingQueries
        ? {
            dehydrate: {
              // include pending queries in dehydration
              shouldDehydrateQuery: (query) => {
                return (
                  defaultShouldDehydrateQuery(query) ||
                  query.state.status === 'pending'
                );
              },
            },
          }
        : {}),
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient(streamPendingQueries = false) {
  if (isServer) {
    return makeQueryClient(streamPendingQueries);
  } else {
    if (!browserQueryClient)
      browserQueryClient = makeQueryClient(streamPendingQueries);
    return browserQueryClient;
  }
}

export const getQueryClientRsc = cache(getQueryClient);
